import { render, staticRenderFns } from "./refund-info.pug?vue&type=template&id=31504096&scoped=true&lang=pug&"
import script from "./refund-info.ts?vue&type=script&lang=ts&"
export * from "./refund-info.ts?vue&type=script&lang=ts&"
import style0 from "./refund-info.styl?vue&type=style&index=0&id=31504096&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31504096",
  null
  
)

export default component.exports